/* Extends the theme variant engine; does not create a second source of variant state. */
(() => {
  if (window.konssyProductEnhancements) return;
  window.konssyProductEnhancements = true;
  function init(root, signal) {
    if (root.dataset.kpReady) return;
    root.dataset.kpReady = 'true';
    const variants = JSON.parse(root.querySelector('[data-variant-json]')?.textContent || '[]');
    const rules = JSON.parse(root.querySelector('[data-kp-quantity-rules]')?.textContent || '{}');
    const money = cents => window.theme?.Currency ? window.theme.Currency.formatMoney(cents, window.theme.settings.moneyFormat) : new Intl.NumberFormat('en-US', { style:'currency', currency:root.dataset.currency || 'USD' }).format(cents / 100);
    const specTemplates = new Map(Array.from(root.querySelectorAll('[data-kp-spec-variant]')).map(t => [t.dataset.kpSpecVariant, t]));
    const descriptionTemplates = new Map(Array.from(root.querySelectorAll('[data-kp-description-variant]')).map(t => [t.dataset.kpDescriptionVariant, t]));
    function prepareDetails(body) {
      body?.querySelectorAll('img').forEach(img => { img.loading='lazy'; img.decoding='async'; });
    }
    prepareDetails(root.querySelector('[data-kp-description-body]'));
    function syncDetails(variant) {
      const template = specTemplates.get(String(variant?.id));
      const copy = template?.content || root.querySelector('[data-kp-copy-default]')?.content;
      if (copy) {
        for (const name of ['title', 'subtitle']) {
          const source = copy.querySelector('[data-kp-copy-' + name + ']');
          root.querySelectorAll('[data-kp-copy-' + name + ']').forEach(target => {
            target.replaceChildren(...(source ? Array.from(source.cloneNode(true).childNodes) : []));
            target.hidden = !target.textContent.trim();
          });
        }
      }
      // Empty/invalid selections must not retain the previous variant's selling points.
      const about = template?.content.querySelector('[data-kp-copy-about]');
      root.querySelectorAll('[data-kp-copy-about]').forEach(target => {
        target.querySelectorAll('video').forEach(video => video.pause());
        target.replaceChildren(...(about ? Array.from(about.cloneNode(true).childNodes) : []));
        const section = target.closest('[data-kp-about-section]');
        if (section) section.hidden = !target.textContent.trim() && !target.querySelector('img,video,iframe');
      });
      root.querySelectorAll('[data-kp-spec-target]').forEach(target => {
        const fragment = template?.content.querySelector('[data-kp-spec-fragment="' + target.dataset.kpSpecTarget + '"]');
        target.replaceChildren(...(fragment ? Array.from(fragment.cloneNode(true).childNodes) : []));
        const section = target.closest('[data-kp-spec-section]');
        if (section) section.hidden = !target.textContent.trim();
      });
      const section = root.querySelector('#kp-product-description');
      const body = section?.querySelector('[data-kp-description-body]');
      const description = variant ? (descriptionTemplates.get(String(variant.id)) || root.querySelector('[data-kp-description-default]')) : null;
      if (body) {
        const key = description?.getAttribute('data-kp-description-variant') || (description ? 'shared' : 'empty');
        if (body.dataset.activeDescription !== key) {
          body.querySelectorAll('video').forEach(v => v.pause());
          body.replaceChildren(...(description ? Array.from(description.content.cloneNode(true).childNodes) : []));
          body.dataset.activeDescription = key;
          prepareDetails(body);
        }
        section.hidden = !body.textContent.trim() && !body.querySelector('img,video,iframe');
        root.querySelectorAll('.kp-detail-link').forEach(link => link.href = section.hidden ? '#kp-product-details' : '#kp-product-description');
      }
    }
    function sync(variant) {
      syncDetails(variant);
      const price = root.querySelector('[data-kp-price]');
      if (price) price.innerHTML = variant ? money(variant.price) : '—';
      const stock = root.querySelector('[data-kp-stock]');
      if (stock) { stock.setAttribute('role','status'); stock.setAttribute('aria-live','polite'); stock.setAttribute('aria-atomic','true'); stock.textContent = variant ? (variant.available ? 'Available' : 'Sold out') : 'Unavailable'; stock.classList.toggle('is-unavailable', !variant?.available); }
      const buy = root.querySelector('[data-kp-buy-now]');
      if (buy) buy.disabled = !variant?.available;
      const sku = root.querySelector('[data-kp-detail-sku]');
      if (sku) sku.textContent = variant?.sku || '—';
      const quantity = root.querySelector('[name="quantity"]');
      if (quantity) {
        const rule = rules[variant?.id] || { min:1, increment:1 };
        quantity.min = rule.min || 1; quantity.step = rule.increment || 1;
        if (rule.max != null) quantity.max = rule.max; else quantity.removeAttribute('max');
        normalizeQuantity(quantity);
      }
      root.querySelectorAll('[data-variant-input]').forEach(input => {
        const selected=Array.from(root.querySelectorAll('[data-variant-input]:checked'));
        const candidate=variants.find(v=>v[input.dataset.index]===input.value&&selected.every(o=>o.dataset.index===input.dataset.index||v[o.dataset.index]===o.value));
        input.setAttribute('aria-label', input.value + (candidate ? (candidate.available ? '' : ', Sold out') : ', Unavailable with current options'));
      });
      root.querySelectorAll('[data-kp-card-value]').forEach(card => {
        const index = Number(card.dataset.kpOptionIndex);
        const selected = Array.from(root.querySelectorAll('[data-variant-input]:checked')).map(input => ({ key:input.dataset.index, value:input.value }));
        const candidate = variants.find(v => v['option' + (index + 1)] === card.dataset.kpCardValue && selected.every(o => o.key === 'option' + (index + 1) || v[o.key] === o.value));
        const label = card.querySelector('.kp-card-price');
        if (label) label.innerHTML = candidate ? money(candidate.price) : 'Unavailable';
        let picture = card.querySelector('img');
        let fallback = card.querySelector('.kp-card-name');
        if (!fallback) { fallback=document.createElement('span'); fallback.className='kp-card-name'; fallback.textContent=card.dataset.kpCardValue; card.prepend(fallback); }
        const src = candidate?.featured_image?.src || candidate?.featured_media?.preview_image?.src;
        let url; try { url = src ? new URL(src, location.origin) : null; } catch {}
        const hasImage = url && ['http:', 'https:'].includes(url.protocol);
        if (hasImage && !picture) { picture=document.createElement('img'); picture.alt=card.dataset.kpCardValue; picture.width=64; picture.height=64; picture.loading='lazy'; card.prepend(picture); }
        fallback.hidden = !!hasImage;
        if (picture) {
          picture.hidden = !hasImage;
          picture.onerror = () => { picture.hidden=true; fallback.hidden=false; };
          if (hasImage) {
            url.searchParams.set('width', '160');
            if (picture.src !== url.href) { picture.removeAttribute('srcset'); picture.src=url.href; }
            else if (picture.complete && !picture.naturalWidth) { picture.hidden=true; fallback.hidden=false; }
          }
        }
        card.setAttribute('aria-label', card.dataset.kpCardValue + (candidate ? (candidate.available ? '' : ', Sold out') : ', Unavailable'));
        card.classList.toggle('disabled', !candidate?.available);
      });
    }
    function normalizeQuantity(input) {
      const min = Number(input.min) || 1, step = Number(input.step) || 1, max = input.max ? Number(input.max) : Infinity;
      let value = Number(input.value);
      if (!Number.isFinite(value)) value = min;
      value = min + Math.max(0, Math.round((value - min) / step)) * step;
      input.value = Math.min(value, Number.isFinite(max) ? Math.max(min, min + Math.floor((max-min)/step)*step) : value);
    }
    root.addEventListener('variantChange', event => sync(event.detail.variant), {signal});
    root.addEventListener('change', event => { if (event.target.name === 'quantity') normalizeQuantity(event.target); }, {signal});
    root.addEventListener('click', event => { if (event.target.closest('.js-qty__adjust')) queueMicrotask(() => { const qty=root.querySelector('[name="quantity"]'); if(qty)normalizeQuantity(qty); }); }, {signal});
    const selectedId = new URL(location.href).searchParams.get('variant') || root.querySelector('[data-product-select]')?.value;
    sync(variants.find(v => String(v.id) === String(selectedId)) || variants.find(v => v.available) || variants[0]);
    root.querySelector('[data-kp-buy-now]')?.addEventListener('click', async event => {
      if (root.hasAttribute('data-local-preview')) return;
      const button = event.currentTarget, form = button.closest('form');
      if (!form || !form.reportValidity()) return;
      const quantity = root.querySelector('[name="quantity"]');
      if (quantity) normalizeQuantity(quantity);
      let error = form.querySelector('.kp-error');
      if (!error) { error=document.createElement('p'); error.className='kp-error'; error.setAttribute('role','alert'); form.append(error); }
      error.textContent=''; button.disabled=true; button.setAttribute('aria-busy','true');
      try {
        const response = await fetch((window.Shopify?.routes?.root || '/') + 'cart/add.js', { method:'POST', headers:{Accept:'application/json'}, body:new FormData(form) });
        const data = await response.json();
        if (!response.ok) throw new Error(data.description || 'Unable to add this item. Please try again.');
        location.assign((window.Shopify?.routes?.root || '/') + 'checkout');
      } catch (err) { error.textContent=err.message; button.disabled=false; button.removeAttribute('aria-busy'); }
    }, {signal});
    return () => { delete root.dataset.kpReady; };
  }
  window.KonssyProductLifecycle.register('product', init);
})();
